var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalCoursePurcha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(-261 -925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invoice-bill-svgrepo-com",
    transform: "translate(261 925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M18,0H5A1.669,1.669,0,0,0,3.33,1.667V15.331H1a1,1,0,0,0-1,1V18a2,2,0,0,0,2,2H14.673a2,2,0,0,0,1.993-2V4.67H19a1,1,0,0,0,1-1V2A2,2,0,0,0,18,0ZM8,2h4a.333.333,0,0,1,0,.667H8A.333.333,0,0,1,8,2ZM5.667,4h8.667a.333.333,0,1,1,0,.667H5.667a.333.333,0,1,1,0-.667Zm0,2h8.667a.333.333,0,1,1,0,.667H5.667a.333.333,0,1,1,0-.667ZM2,19.333A1.335,1.335,0,0,1,.667,18V16.333A.337.337,0,0,1,1,16l11.664,0v2c0,.024.006.047.007.07s.006.074.01.111a1.99,1.99,0,0,0,.494,1.152Zm9.667-4.667a3.668,3.668,0,0,1-3.262-2H5.667a.333.333,0,1,1,0-.667H8.142A3.655,3.655,0,0,1,8,11c0-.113.007-.223.017-.333H5.667a.333.333,0,1,1,0-.667H8.142a3.665,3.665,0,0,1,.7-1.333H5.667a.333.333,0,1,1,0-.667h3.9a3.665,3.665,0,1,1,2.1,6.667Zm7.667-11A.337.337,0,0,1,19,4h-2.33V2a1.333,1.333,0,1,1,2.667,0V3.667Z",
    transform: "translate(0 0)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M224.543,204.8a2.676,2.676,0,1,0,2.676,2.676A2.679,2.679,0,0,0,224.543,204.8Zm1.734,1.651-1.784,2.676a.3.3,0,0,1-.218.131h-.029a.3.3,0,0,1-.21-.087l-1.189-1.189a.3.3,0,0,1,.42-.42l.933.933,1.583-2.374a.3.3,0,1,1,.495.33Z",
    transform: "translate(-212.799 -196.426)",
    fill: "#136ad0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCoursePurcha);
export default __webpack_public_path__ + "static/media/total-course-purcha.993ed83e1fc9b253363f204e00f052ea.svg";
export { ForwardRef as ReactComponent };